import React from 'react';
import Layer from '../Layer';
import './ImageLayer.less';

function ImageLayer({src, noPadding=false, ...props}) {
  return (
    <Layer {...props}>
      <div className='ImageLayer' data-padding={!noPadding ? true : null}>
        <img src={src} alt='image'/>
      </div>
    </Layer>
  );
}

export default ImageLayer;


// WEBPACK FOOTER //
// ./src/components/ImageLayer/ImageLayer.js